import { render, staticRenderFns } from "./noticeds.vue?vue&type=template&id=45364c9d&"
import script from "./noticeds.vue?vue&type=script&lang=js&"
export * from "./noticeds.vue?vue&type=script&lang=js&"
import style0 from "./noticeds.vue?vue&type=style&index=0&id=45364c9d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports